<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="account-page">
        <account-left></account-left>
        <div class="act-page-right">
          <div class="act-c-hd">
            <div class="user-info">
              <div class="tx">
                <el-upload ref="upload" class="avatar-uploader" :action="upUrl" :headers="upHeader"
                  accept=".jpg, .jpeg, .png, .gif, .JPG, .JPEG, .PBG, .GIF" :show-file-list="false"
                  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-remove="handleRemove"
                  :on-error="handleError">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <img v-if="isShowpic" src="/static/img/tx.jpg" class="avatar" />
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                </el-upload>

              </div>
              <div class="r-info">
                <div class="name-g">
                  <span class="name">{{ user.NAME }}</span>
                </div>
                <div class="phone-n">{{ http.GetOrgInfo().LoginMode == 1 ? "TEL" : "Account" }}：{{ user.TEL }}</div>
                <!-- <div class="phone-n">所在学校：{{ user.SCHOOLNAME }}</div> -->
              </div>
            </div>
            <span class="icon iconfont icon-bianji" @click="modifyInfo"></span>
          </div>
          <div class="act-c-bd">
            <!--            <div class="item">-->
            <!--              <div class="hd-title">个人信息</div>-->
            <!--              <div class="bd-info">-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">我的等级：</span>-->
            <!--                  <span class="tj-num">1</span>-->
            <!--                </div>-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">进度：</span>-->
            <!--                  <div class="tj-progress">-->
            <!--                    <span class="start">LV1</span>-->
            <!--                    <el-progress :text-inside="true" :stroke-width="22" :percentage="80" status="warning"></el-progress>-->
            <!--                    <span class="end">LV2</span>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">可用积分：</span>-->
            <!--                  <span class="tj-num">0</span>分-->
            <!--                  <span class="ou-btn">查看积分详情</span>-->
            <!--                </div>-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">经验值：</span>-->
            <!--                  <span class="tj-num">10</span>分-->
            <!--                  <span class="ou-btn">经验值说明</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="item">-->
            <!--              <div class="hd-title">账户管理</div>-->
            <!--              <div class="bd-info">-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">账户余额：</span>-->
            <!--                  <span class="tj-num">0</span>阅点-->
            <!--                  <span class="ou-btn">余额查询</span>-->
            <!--                  <span class="ou-btn">消费记录</span>-->
            <!--                </div>-->
            <!--                <div class="bd-item">-->
            <!--                  <span class="ti">红包余额：</span>-->
            <!--                  <span class="tj-num">0</span>阅点-->
            <!--                  <span class="ou-btn">查看我的红包</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="item">
              <div class="hd-title">My Reading</div>
              <div class="bd-info">
                <div class="bd-item">
                  <span class="ti">Yesterday's reading：</span>
                  <span class="tj-num">{{ model.ReadMinuteToday }}</span>minute
                </div>
                <div class="bd-item">
                  <span class="ti">Accumulated reading：</span>
                  <span class="tj-num">{{ model.ReadMinuteTotal }}</span>minute
                </div>
                <div class="bd-item">
                  <span class="ti">My bookshelf：</span>
                  <span class="tj-num">{{ user.TOTALCOLLECTCOUNT }}</span>books
                  <router-link class="ou-btn" :to="'/bookshelf'">go bookshelf</router-link>
                </div>
                <div class="bd-item" v-show="false">
                  <span class="ti">My footprint：</span>
                  <span class="tj-num">{{ user.TOTALREADCOUNT }}</span>view
                  <router-link class="ou-btn" :to="'/footprint'">go footprint</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import AccountLeft from "common/other/AccountLeft";
export default {
  name: "Myaccount",
  components: {
    CommonHead,
    CommonFoot,
    AccountLeft,
  },
  data() {
    return {
      isShowpic: false,
      isCollapse: false,
      upHeader: {
        Authorization: window.localStorage.Token,
      },
      upUrl: this.http.ipAddress + `Center/UploadPhoto?path=member`,
      imageUrl: "",
      imageUrl1: "",
      model: {},
      user: {},
    };
  },
  mounted: function () {
    // let url = this.$bti.GetMember(null, true);
    // this.http.postParam(url, {}, "正在获取...").then((res) => {
    //   this.model = res.data;
    //   this.user = this.model.User;
    //   if (this.user.PHOTO) {
    //    this.imageUrl = this.http.ipAddress + `${this.user.PHOTO.substring(1)}`;
    //   }
    //   if (this.imageUrl) {
    //     this.isShowpic = false
    //   } else {
    //     this.isShowpic = true
    //   }
    // });
    this.Member();
  },
  methods: {
    Member() {
      let url = this.$bti.GetMember(null, true);
    this.http.postParam(url, {}, "正在获取...").then((res) => {
      this.model = res.data;
      this.user = this.model.User;
      if (this.user.PHOTO) {
       this.imageUrl = this.http.ipAddress + `${this.user.PHOTO.substring(1)}`;
      }
      if (this.imageUrl) {
        this.isShowpic = false
      } else {
        this.isShowpic = true
      }
    });
    },
    // 保存头像接口
    onSubmit() {
      let url = this.$bti.SaveUserPhoto(null, true);
      this.http.postParam(url, { PHOTO: this.imageUrl1 }, "正在保存...").then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.info);
        } else {
           if (res.data.PHOTO !== "" && res.data.PHOTO !== undefined) {
              this.imageUrl = this.http.ipAddress + `${res.data.PHOTO.substring(1)}`;
           }
          if (this.imageUrl) {
            this.isShowpic = false
          } else {
            this.isShowpic = true
          }
          let url = this.$bti.GetRefreshToken(null, true);
          this.http.postParam(url, {}, "正在刷新...")
            .then((r) => {
              if (r.code === 1) {
                let token = r.token;
                this.$store.commit("saveToken", token);
                this.$forceUpdate()
              } else {
                console.log(r.info);
              }
            })
          this.$message({
            type: "success",
            message: "success",
            duration: 3000,
          });
          this.Member();
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.imageUrl1 = res.data.path;
        this.onSubmit();
      }
      this.$refs.upload.clearFiles(); // 上传成功之后清除历史记录
    },
    beforeAvatarUpload(file) {
      const typeList = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      let isImg = typeList.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isImg) {
        this.$message.error("格式错误，请上传 JPG/JPEG/PNG/GIF 格式图片!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
        return false;
      }
    },
    //  handlePreview(file) {
    //   this.imgUrl = file.url;
    // },
    handleError() {
      this.$message({
        title: "错误",
        type: "error",
        message: "上传失败",
      });
    },
    handleRemove(file, fileList) {
      if (this.imageUrl) {
        this.fileList = [];
        this.imageUrl = "";
      }
    },
    modifyInfo() {
      this.$prompt("My name", "modify", {
        inputValue: this.user.NAME,
        confirmButtonText: "sure",
        cancelButtonText: "cancel",
      })
        .then(({ value }) => {
          let that = this;
          let url = this.$bti.SaveUserInfo(null, true);
          that.http
            .postParam(url, {
              NAME: value,
            }, "正在保存...")
            .then((res) => {
              if (res.code != 1) {
                this.$message.error(res.info);
              } else {
                this.user = res.data;
                this.$message({
                  type: "success",
                  message: "success",
                  duration: 3000,
                });
                this.Member();
              }
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="css" scoped>
.act-c-hd {
  position: relative;
}

.act-c-hd .icon-bianji {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  font-size: 28px;
  font-weight: bold;
  color: #999;
}

.act-c-hd .user-info .tx {
  float: left;
  width: 120px;
  height: 120px;
  padding: 4px;
  border: 1px solid #ccc;
}
.act-c-hd .user-info .tx .avatar-uploader{
  width: 112px;
  height: 112px;
}
.act-c-hd .user-info .tx .avatar-uploader img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.act-c-hd .user-info .tx .avatar-uploader .avatar{
   width: 112px;
  height: 112px;
}
.act-c-hd .user-info .r-info {
  float: left;
  width: 400px;
  margin-left: 20px;
}

.act-c-hd .user-info .r-info .name-g .name {
  font-size: 22px;
  font-weight: bold;
}

.act-c-hd .user-info .r-info .name-g .gen {
  padding-left: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #999;
}

.act-c-hd .user-info .r-info .phone-n {
  margin-top: 10px;
  font-size: 14px;
}

.act-c-bd {
  margin-top: 20px;
}

.act-c-bd .item {
  padding: 15px 0px;
}

.act-c-bd .hd-title {
  font-size: 16px;
  font-weight: bold;
  height: 35px;
  line-height: 35px;
}

.act-c-bd .bd-info {
  background: #f4f4f4;
  padding: 20px;
  margin-top: 10px;
}

.act-c-bd .bd-info .bd-item {
  float: left;
  width: 50%;
  padding-right: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 14px;
  color: #6c7172;
  padding: 8px 0;
}

.act-c-bd .bd-info .bd-item .ti {
  /*font-weight: bold;*/
  padding-right: 10px;
}

.act-c-bd .bd-info .bd-item .tj-num {
  font-weight: bold;
  color: red;
  padding-right: 10px;
}

.act-c-bd .bd-info .bd-item .ou-btn {
  font-weight: bold;
  color: #2a6eb3;
  padding-left: 15px;
  cursor: pointer;
}

.tj-progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/Myaccount.vue